import React from "react";
import PropTypes from "prop-types";

import "./Section.scss";

const Section = ({ title, subtitle, children, className, extra }) => (
  <section className={`b-section ${className?className:""}`}>
    {title && <header>{title}</header>}
    {subtitle && <div className="b-section__subtitle">{subtitle}</div>}
    {extra}
    <div className="b-section__content">{children}</div>
  </section>
);

Section.propTypes = {
  children: PropTypes.element,
  title: PropTypes.element,
  subtitle: PropTypes.element,
  className: PropTypes.string,
  extra: PropTypes.element,
};

Section.defaultProps = {
  children: null,
  subtitle: null,
  title: null,
  extra: null,
  className: "",
};

export default Section;
